module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAABQUlEQVRIS73WsU7CQBzH8d/fMjhUVh6BmMZFVgdwBR7A1dHROPkMytYXIU0YeQIGEmBQV0h4hKbaMz1t9eDa/q+90rnJ93Nt738lnOi6Hr5d0lnkhxTfraZX+zRLp+jLOEVzAB0QNiHFtymicYAS/1t2hmgUoI0fIBoDFMYlgoQgum8EwIkD4mkReBPrAJO4fA42d4Fp/Ajg9dfuuUv+J5znZdDdmuCqxBXATxwzADcCeP9Ca8BFVI1ngP/xdNVcRJ24BOjiXETduAT0xpsHCOHnve+8J2Ejnr2C3mj9CuCRi7AVVz5CLsIR1M4OFq2YRDpkOLtImQNlCAAfAC7kqWYhrh1EDETOwsxWXvg/YI6oFi8cxXxE9XjpWVCOqBcvBSQ35CPqx1kAPcJOnA1QEfbiRoBfxAuAXfInwxkynHu+ASJ56TPxdxlmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/checked-blue.png
// module id = 1645
// module chunks = 0